export const EVENT_WIDGET_INITIALIZED = 'initialized';
export const EVENT_FORM_FIELDS_TOUCHED = 'form_fields_touched';
export const EVENT_FORM_SUBMITTED = 'form_submited';

export const FORM_EVENTS = {
  initialized: EVENT_WIDGET_INITIALIZED,
  touched: EVENT_FORM_FIELDS_TOUCHED,
  submitted: EVENT_FORM_SUBMITTED,
};

// GEO LOCATOR WIDGET
export const GEO_LOCATOR_EVENTS_CHANNEL = 'geo_locator:events';
export const GEO_LOCATOR_CITY_SELECTED_EVENT = 'city_selected';

// INSTOCK WIDGET
export const INSTOCK_CHANNEL = 'instock:events';
export const INSTOCK_CAR_DATA_RECEIVED_EVENT = 'car_data_received';
